/*
 * @Author: Jun
 * @Date: 2021-05-11 13:31:33
 * @LastEditTime: 2021-05-17 15:42:50
 * @LastEditors: JUN
 * @Description: 
 * @FilePath: /agriculture/src/components/Auth/Picker/config.js
 */
export default {
    school: {
        title: '学校',
        list: []
    },
    identity_type: {
        title: '身份',
        list: [
            { key: 'normal', text: '我是居民'},
            { key: 'student', text: '我是中学生'},
        ]
    },
}